import React from "react";

const ExpandBoard = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2H2V3V9H4V5.41421L13.2929 14.7071L14.7071 13.2929L5.41421 4H9V2H3ZM12 4H17C17.1748 4 17.4332 4.09745 17.6679 4.33211C17.9025 4.56676 18 4.82523 18 5V17C18 17.1748 17.9025 17.4332 17.6679 17.6679C17.4332 17.9025 17.1748 18 17 18H5C4.82523 18 4.56676 17.9025 4.33211 17.6679C4.09745 17.4332 4 17.1748 4 17V12H2V17C2 17.8252 2.40255 18.5668 2.91789 19.0821C3.43324 19.5975 4.17477 20 5 20H17C17.8252 20 18.5668 19.5975 19.0821 19.0821C19.5975 18.5668 20 17.8252 20 17V5C20 4.17477 19.5975 3.43324 19.0821 2.91789C18.5668 2.40255 17.8252 2 17 2H12V4Z"
        fill="black"
      />
    </svg>
  );
};

export default ExpandBoard;
